import React, { useEffect, useState } from "react";
import { Box, CircularProgress, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { useTranslation } from "react-i18next";
import { useSound } from "../../../../../../context/juno/SoundContext";
import { useAlert } from "../../../../../../context/AlertContext";
import Cookies from "js-cookie";
import { ColumnBox } from "../../../../../../utils/styledBox";

const LyricControl: React.FC = () => {
  const { t } = useTranslation();
  const { lyric, setLyric, aiEngine } = useSound();
  const { setAlert } = useAlert();
  const [onlyEnglish, setOnlyEnglish] = React.useState(false);
  const [isEnhancing, setIsEnhancing] = useState(false);

  useEffect(() => {
    if (aiEngine === "DIFFRHYTHM") {
      setOnlyEnglish(true);
    }
  }, [aiEngine]);

  // 歌詞強化機能
  const handleEnhanceLyric = async () => {
    if (!lyric.trim()) {
      setAlert("error", t("juno.sound.error.lyric.empty"));
      return;
    }

    try {
      setIsEnhancing(true);

      const url = "/api/v1/juno/sound/enhance-lyric";
      const csrftoken = Cookies.get("csrftoken");
      const headers = new Headers({
        "Content-Type": "application/json",
        "X-CSRFToken": csrftoken!,
      });

      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          lyric: lyric,
          model: aiEngine,
        }),
      });

      const data = await response.json();
      if (data.lyric) {
        setLyric(data.lyric);
      }
    } catch (e) {
      console.error(e);
      setAlert("error", t("juno.sound.error.lyric.enhance"));
    } finally {
      setIsEnhancing(false);
    }
  };

  return (
    <ColumnBox>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Typography variant="body2" sx={{ mr: 1 }}>
          {t("juno.sound.params.lyric")}
        </Typography>
        {/* 歌詞強化アイコン */}
        <Tooltip title={t("juno.sound.inspire.improve")} placement="top">
          <span>
            <IconButton size="small" onClick={handleEnhanceLyric} disabled={isEnhancing || !lyric.trim()}>
              {isEnhancing ? <CircularProgress size={16} color="primary" /> : <AutoFixHighIcon fontSize="small" />}
            </IconButton>
          </span>
        </Tooltip>
        <Box sx={{ flexGrow: 1 }} />
        <Tooltip title={t("juno.sound.params.lyricHelp")} placement="top">
          <IconButton size="small">
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <TextField
        value={lyric}
        onChange={(e) => setLyric(e.target.value)}
        multiline
        minRows={1}
        maxRows={10}
        placeholder={t("juno.sound.params.lyricPlaceholder")}
        variant="standard"
        fullWidth
        inputProps={{ maxLength: aiEngine === "MINIMAX" ? 200 : 1000 }} // 最大文字数を設定
      />
      {onlyEnglish && (
        <Typography variant="caption" color="warning.main">
          {t("juno.sound.params.lyricOnlyEnglish")}
        </Typography>
      )}
    </ColumnBox>
  );
};

export default LyricControl;
